import IndexPage from './pages';

function App() {
  return <IndexPage />;
}

export default App;
